import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/committed-cost")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "8f8163b5-f959-5b08-bac1-613745052ae8" }, replace: true });
  },
  component: () => null,
});
